import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-expeditions',
  templateUrl: './expeditions.component.html',
  styleUrls: ['./expeditions.component.scss']
})
export class ExpeditionsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
